/*
 * Footer "Join the newsletter" panel. Any a[href$="#join"] (the markets
 * footnote, the FAQ newsletter answer) opens the <details id="join"> in the
 * footer, scrolls to it and focuses the email field. Without JS the details
 * still opens by click and /#join jumps to it.
 */
(function () {
  if (window.footerJoinInitialised) return;
  window.footerJoinInitialised = true;

  function openJoin() {
    var panel = document.getElementById('join');
    if (!panel || panel.tagName !== 'DETAILS') return false;
    panel.open = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    panel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    var input = panel.querySelector('input[type="email"]');
    if (input) input.focus({ preventScroll: true });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href$="#join"]');
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (openJoin()) event.preventDefault();
  });

  /* The merchant chose a one-way disclosure: the summary hides once open, so
     the panel cannot be collapsed again until reload. Move focus to the email
     field so keyboard users who opened it with Enter/Space do not lose it. */
  var joinPanel = document.getElementById('join');
  if (joinPanel && joinPanel.tagName === 'DETAILS') {
    joinPanel.addEventListener('toggle', function () {
      var a = document.activeElement;
      /* Focus on the summary does not count: CSS hides it once open. */
      if (!joinPanel.open || (joinPanel.contains(a) && a.tagName !== 'SUMMARY')) return;
      /* After a successful post the thank-you takes focus (it is announced);
         the sync focus below can miss at load, before layout, so the toggle
         retries it rather than falling through to the email field. */
      var posted = location.hash === '#ContactFooter' && joinPanel.querySelector('#ContactFooter-success');
      var field = posted || joinPanel.querySelector('input[type="email"]');
      if (field) field.focus({ preventScroll: true });
    });
  }

  if (location.hash === '#join') openJoin();

  /* After a post Shopify reloads to #ContactFooter. The newsletter strip is
     also a customer form, so posted state shows in both forms; only the one
     the hash names keeps its message, opens and takes focus. */
  var form = document.getElementById('ContactFooter');
  if (form) {
    var message = form.querySelector('#ContactFooter-success, #ContactFooter-error');
    if (location.hash === '#ContactFooter') {
      var panel = document.getElementById('join');
      if (panel && message) {
        panel.open = true;
        if (message.id === 'ContactFooter-success') {
          message.focus({ preventScroll: true });
        } else {
          var email = panel.querySelector('input[type="email"]');
          if (email) email.focus({ preventScroll: true });
        }
        panel.scrollIntoView({ block: 'center' });
      }
    } else if (message) {
      form.querySelectorAll('#ContactFooter-success, #ContactFooter-error').forEach(function (el) { el.remove(); });
      var field = form.querySelector('input[type="email"]');
      if (field) {
        field.removeAttribute('aria-describedby');
        field.removeAttribute('aria-invalid');
      }
    }
  }
})();
